function getMetadata(missionId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
  };

  return fetch(`/metadata/${missionId}`, requestOptions);
}

export const metadataService = {
  getMetadata,
};
